export function currenciesConverter(list: any, rate: number) {
  const currencyCode = Object.keys(list)[0] || null;

  const value = currencyCode ? list[currencyCode] : 1;
  return value * rate;
}